import { t as e } from "../../utils-DiFe-_ei.js";
import { t } from "../../createLucideIcon-CJLgHpqc.js";
import { Typography as n } from "../../foundations/typography.js";
import "../../typography-CTPDhvds.js";
import { i as r, n as i, t as a } from "../../tooltip-BBk91-lt.js";
import "../../tooltip-CVlMtE-y.js";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
var c = t("circle-alert", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["line", {
		x1: "12",
		x2: "12",
		y1: "8",
		y2: "12",
		key: "1pkeuh"
	}],
	["line", {
		x1: "12",
		x2: "12.01",
		y1: "16",
		y2: "16",
		key: "4dfq90"
	}]
]), l = t("info", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "10",
		key: "1mglay"
	}],
	["path", {
		d: "M12 16v-4",
		key: "1dtifu"
	}],
	["path", {
		d: "M12 8h.01",
		key: "e9boi3"
	}]
]), u = t("triangle-alert", [
	["path", {
		d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
		key: "wmoenq"
	}],
	["path", {
		d: "M12 9v4",
		key: "juzpu7"
	}],
	["path", {
		d: "M12 17h.01",
		key: "p32p05"
	}]
]), d = {
	DEV: "bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-200",
	UAT: "bg-purple-50 text-purple-700 ring-1 ring-inset ring-purple-200"
};
function f({ env: t }) {
	let n = t === "prod" ? null : t === "uat" ? "UAT" : "DEV";
	return n ? /* @__PURE__ */ o("span", {
		className: e("inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-xs font-semibold", d[n]),
		children: n
	}) : null;
}
//#endregion
//#region src/components/status/StatusBadge/StatusBadge.tsx
var p = {
	DRAFT: {
		pill: "bg-sky-50 text-sky-800",
		dot: "bg-sky-500"
	},
	SENT: {
		pill: "bg-amber-50 text-amber-800",
		dot: "bg-amber-500"
	},
	PAID: {
		pill: "bg-emerald-50 text-emerald-800",
		dot: "bg-emerald-600"
	},
	OVERDUE: {
		pill: "bg-red-50 text-red-800",
		dot: "bg-red-600"
	},
	CANCELLED: {
		pill: "bg-rose-50 text-rose-800",
		dot: "bg-rose-500"
	},
	VOID: {
		pill: "bg-stone-100 text-stone-600",
		dot: "bg-stone-400"
	},
	ACCEPTED: {
		pill: "bg-emerald-50 text-emerald-800",
		dot: "bg-emerald-600"
	},
	DECLINED: {
		pill: "bg-red-50 text-red-800",
		dot: "bg-red-600"
	},
	EXPIRED: {
		pill: "bg-orange-50 text-orange-700",
		dot: "bg-orange-500"
	},
	SUPERSEDED: {
		pill: "bg-stone-100 text-stone-600",
		dot: "bg-stone-400"
	},
	INVOICED: {
		pill: "bg-violet-50 text-violet-700",
		dot: "bg-violet-500"
	}
}, m = {
	DRAFT: "Draft",
	SENT: "Sent",
	PAID: "Paid",
	OVERDUE: "Overdue",
	CANCELLED: "Cancelled",
	VOID: "Void",
	ACCEPTED: "Accepted",
	DECLINED: "Declined",
	EXPIRED: "Expired",
	SUPERSEDED: "Superseded",
	INVOICED: "Invoiced"
};
function h({ status: e, styles: t = p, labels: n = m, description: c }) {
	let l = t[e] ?? {
		pill: "bg-stone-100 text-stone-600",
		dot: "bg-stone-500"
	}, u = n[e] ?? e, d = /* @__PURE__ */ s("span", {
		className: `inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium ${l.pill}`,
		tabIndex: c ? 0 : void 0,
		children: [/* @__PURE__ */ o("span", { className: `size-1.5 shrink-0 rounded-full ${l.dot}` }), u]
	});
	return c ? /* @__PURE__ */ s(a, { children: [/* @__PURE__ */ o(r, {
		asChild: !0,
		children: d
	}), /* @__PURE__ */ o(i, {
		className: "max-w-64",
		children: c
	})] }) : d;
}
//#endregion
//#region src/components/status/InfoTip/InfoTip.tsx
function g({ children: t, label: n = "More information", className: c }) {
	return /* @__PURE__ */ s(a, { children: [/* @__PURE__ */ o(r, {
		asChild: !0,
		children: /* @__PURE__ */ o("button", {
			type: "button",
			"aria-label": n,
			className: e("text-muted-foreground hover:text-foreground inline-flex rounded-full align-middle transition-colors", c),
			children: /* @__PURE__ */ o(l, {
				className: "size-3.5",
				"aria-hidden": "true"
			})
		})
	}), /* @__PURE__ */ o(i, {
		className: "max-w-64",
		children: t
	})] });
}
//#endregion
//#region src/components/status/Notice/Notice.tsx
var _ = {
	info: {
		className: "border-sky-200 bg-sky-50 text-sky-900 dark:border-sky-900/60 dark:bg-sky-950/40 dark:text-sky-200",
		icon: l
	},
	warning: {
		className: "border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900/60 dark:bg-amber-950/40 dark:text-amber-300",
		icon: u
	},
	danger: {
		className: "border-red-200 bg-red-50 text-red-900 dark:border-red-900/60 dark:bg-red-950/40 dark:text-red-200",
		icon: c
	}
};
function v({ tone: t = "info", title: r, children: i, icon: a, className: c }) {
	let { className: l, icon: u } = _[t], d = a ?? u;
	return /* @__PURE__ */ s("div", {
		"data-tone": t,
		className: e("flex gap-3 rounded-lg border p-3.5", l, c),
		children: [/* @__PURE__ */ o(d, {
			className: "mt-0.5 size-4 shrink-0",
			"aria-hidden": "true"
		}), /* @__PURE__ */ s("div", {
			className: "min-w-0 space-y-1",
			children: [r && /* @__PURE__ */ o(n, {
				as: "p",
				variant: "body-sm",
				className: "font-semibold text-inherit",
				children: r
			}), i && /* @__PURE__ */ o(n, {
				as: "div",
				variant: "body-sm",
				className: "text-inherit opacity-90",
				children: i
			})]
		})]
	});
}
//#endregion
export { f as EnvBadge, g as InfoTip, v as Notice, m as STATUS_LABELS, p as STATUS_STYLES, h as StatusBadge };

//# sourceMappingURL=index.js.map